"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    n = require("react"),
    t = (e = n) && "object" == typeof e && "default" in e ? e["default"] : e;

function r() {
  return (r = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function o(e, n) {
  if (null == e) return {};
  var t,
      r,
      o = {},
      u = Object.keys(e);

  for (r = 0; r < u.length; r++) {
    n.indexOf(t = u[r]) >= 0 || (o[t] = e[t]);
  }

  return o;
}

var u = f() ? t.useLayoutEffect : t.useEffect,
    c = u;

function i(e, n) {
  if (null != e) if ("function" == typeof e) e(n);else try {
    e.current = n;
  } catch (t) {
    throw new Error('Cannot assign value "' + n + '" to ref "' + e + '"');
  }
}

function f() {
  return "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement;
}

function s(e, t) {
  var r = n.createContext(t);
  return r.displayName = e, r;
}

function a() {}

exports.DescendantProvider = function (e) {
  var u = e.context,
      c = e.children,
      i = e.items,
      f = e.set,
      s = t.useCallback(function (e) {
    var n = e.element,
        t = o(e, ["element"]);
    n && f(function (e) {
      if (null == e.find(function (e) {
        return e.element === n;
      })) {
        var o = e.findIndex(function (e) {
          var t = e.element;
          return !(!t || !n) && Boolean(t.compareDocumentPosition(n) & Node.DOCUMENT_POSITION_PRECEDING);
        }),
            u = r({
          element: n,
          index: o
        }, t);
        return -1 === o ? [].concat(e, [u]) : [].concat(e.slice(0, o), [u], e.slice(o));
      }

      return e;
    });
  }, []),
      a = n.useCallback(function (e) {
    e && f(function (n) {
      return n.filter(function (n) {
        return e !== n.element;
      });
    });
  }, []),
      l = n.useMemo(function () {
    return {
      descendants: i,
      registerDescendant: s,
      unregisterDescendant: a
    };
  }, [i, s, a]);
  return t.createElement(u.Provider, {
    value: l
  }, c);
}, exports.assignRef = i, exports.boolOrBoolString = function (e) {
  return "false" !== e && Boolean(e);
}, exports.canUseDOM = f, exports.checkStyles = function (e) {}, exports.cloneValidElement = function (e, t) {
  if (!n.isValidElement(e)) return e;

  for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), u = 2; u < r; u++) {
    o[u - 2] = arguments[u];
  }

  return n.cloneElement.apply(void 0, [e, t].concat(o));
}, exports.createDescendantContext = function (e, n) {
  return void 0 === n && (n = {}), s(e, r({
    descendants: [],
    registerDescendant: a,
    unregisterDescendant: a
  }, n));
}, exports.createNamedContext = s, exports.findLastIndex = function (e, n) {
  var t = e.length >>> 0;
  if (!t) return -1;

  for (var r = t - 1; r >= 0;) {
    if (n(e[r], r, e)) return r;
    --r;
  }

  return -1;
}, exports.forwardRefWithAs = function (e) {
  return t.forwardRef(e);
}, exports.getScrollbarOffset = function () {
  try {
    if (window.innerWidth > document.documentElement.clientWidth) return window.innerWidth - document.documentElement.clientWidth;
  } catch (e) {}

  return 0;
}, exports.isUndefined = function (e) {
  return void 0 === e;
}, exports.makeId = function () {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++) {
    n[t] = arguments[t];
  }

  return n.filter(function (e) {
    return null != e;
  }).join("--");
}, exports.noop = a, exports.useConstant = function (e) {
  var n = t.useRef();
  return n.current || (n.current = {
    v: e()
  }), n.current.v;
}, exports.useDescendant = function (e, t) {
  var u = e.context,
      i = e.element,
      f = o(e, ["context", "element"]),
      s = n.useState()[1],
      a = n.useContext(u),
      l = a.registerDescendant,
      d = a.unregisterDescendant,
      p = a.descendants;
  return c(function () {
    return i || s({}), l(r({
      element: i
    }, f)), function () {
      return d(i);
    };
  }, [i].concat(Object.values(f))), null != t ? t : p.findIndex(function (e) {
    return e.element === i;
  });
}, exports.useDescendants = function () {
  return n.useState([]);
}, exports.useForkedRef = function () {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
    t[r] = arguments[r];
  }

  return n.useMemo(function () {
    return t.every(function (e) {
      return null == e;
    }) ? null : function (e) {
      t.forEach(function (n) {
        i(n, e);
      });
    };
  }, t);
}, exports.useIsomorphicLayoutEffect = u, exports.usePrevious = function (e) {
  var t = n.useRef(null);
  return n.useEffect(function () {
    t.current = e;
  }, [e]), t.current;
}, exports.useUpdateEffect = function (e, t) {
  var r = n.useRef(!1);
  n.useEffect(function () {
    r.current ? e() : r.current = !0;
  }, t);
}, exports.wrapEvent = function (e, n) {
  return function (t) {
    if (e && e(t), !t.defaultPrevented) return n(t);
  };
};